import { useTranslation } from 'react-i18next';
import { useConfig } from '../../../components/HotelDetailsOverlay/context/Config.js';
import { RATING_SENTIMENT_DISSATISFIED, RATING_SENTIMENT_HIGHLY_SATISFIED, RATING_SENTIMENT_SATISFIED, RATING_SENTIMENT_VERY_DISSATISFIED, RATING_SENTIMENT_VERY_SATISFIED } from '../../../primitives/Rating/index.js';
export const useAmadeusRating = () => {
  const {
    amadeusRating: {
      scoreMaxBackend,
      scoreMaxFrontend,
      scoreThresholds
    }
  } = useConfig();
  const {
    t
  } = useTranslation();
  const mapScore = score => {
    if (score >= scoreThresholds.excellent.min) {
      return {
        sentiment: RATING_SENTIMENT_HIGHLY_SATISFIED,
        scoreRangeMin: scoreThresholds.excellent.min.toFixed(1),
        scoreRangeMax: scoreMaxFrontend.toFixed(1)
      };
    }
    if (score >= scoreThresholds.veryGood.min) {
      return {
        sentiment: RATING_SENTIMENT_VERY_SATISFIED,
        scoreRangeMin: scoreThresholds.veryGood.min.toFixed(1),
        scoreRangeMax: scoreThresholds.veryGood.max.toFixed(1)
      };
    }
    if (score >= scoreThresholds.good.min) {
      return {
        sentiment: RATING_SENTIMENT_SATISFIED,
        scoreRangeMin: scoreThresholds.good.min.toFixed(1),
        scoreRangeMax: scoreThresholds.good.max.toFixed(1)
      };
    }
    if (score >= scoreThresholds.fair.min) {
      return {
        sentiment: RATING_SENTIMENT_DISSATISFIED,
        scoreRangeMin: scoreThresholds.fair.min.toFixed(1),
        scoreRangeMax: scoreThresholds.fair.max.toFixed(1)
      };
    }
    return {
      sentiment: RATING_SENTIMENT_VERY_DISSATISFIED,
      scoreRangeMin: scoreThresholds.weak.min.toFixed(1),
      scoreRangeMax: scoreThresholds.weak.max.toFixed(1)
    };
  };
  return rawScore => {
    const scoreScaled = rawScore / (scoreMaxBackend / scoreMaxFrontend);
    const score = Math.ceil(scoreScaled * 10) / 10;
    const {
      scoreRangeMax,
      scoreRangeMin,
      sentiment
    } = mapScore(score);
    const scoreFormatted = score.toFixed(1);
    const scoreMax = scoreMaxFrontend.toFixed(0);
    const scorePercentage = Math.round(scoreScaled * 100 / scoreMaxFrontend);
    const scoreDescription = t(`hotelDetailsOverlay:amadeusRatingSection.score.categories.${sentiment}`);
    return {
      score,
      scoreFormatted,
      scoreDescription,
      scorePercentage,
      scoreMax,
      sentiment,
      scoreRangeMin,
      scoreRangeMax
    };
  };
};